<template>
  <section>
    <gs-header title="Thêm mới bảng giá"
      :breadcrumbs="[
        {title: 'Quản lý bảng giá', route: {name: 'price-table'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all" v-if="isLoading">
      <el-form v-loading.fullscreen.lock="submitting" element-loading-text="Đang thêm mới bảng giá vui lòng đợi..." label-position="top" class="margin-top" :rules="rules" ref="create-price-table-form" :model="localPriceTable" label-width="150px" @submit.prevent.native="validatorBeforeSubmit" >
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Tên" prop="name">
              <el-input v-model="localPriceTable.name" placeholder="Tên"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Hãng vận chuyển" class="is-required" prop="carrier_id">
              <el-select class="display-block " v-model="localPriceTable.carrier_id" filterable placeholder="Chọn hãng vận chuyển">
                <el-option
                  v-for="carrier in carriers"
                  :key="carrier.id"
                  :label="carrier.name"
                  :value="carrier.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="8">
            <el-form-item label="Dịch vụ" class="is-required" prop="service_id">
              <el-select class="width-100" v-model="localPriceTable.service_id" filterable placeholder="Chọn dịch vụ">
                <el-option
                  v-for="service in services"
                  :key="service.id"
                  :label="service.name"
                  :value="service.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Mapping id" prop="service_mapping_id">
              <el-select class="width-100" clearable v-model="localPriceTable.service_mapping_id" filterable placeholder="Mapping id">
                <el-option-group
                  v-for="(sGroup, key, index) in priceTableHelpers.services"
                  :label="key"
                  :key="key">
                  <el-option
                    v-for="(service, key, index) in sGroup"
                    :label="service"
                    :value="key"
                    :key="key">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="Giờ áp dụng" prop="hour_apply">
              <el-input @focus="removeZero('hour_apply')" @blur="addZero('hour_apply')" v-model="localPriceTable.hour_apply" placeholder="Giờ áp dụng">
                <div slot="append">Giờ</div>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="adddon-3">
            <el-form-item label="Thời gian dự kiến giao hàng" prop="expected_delivery">
              <el-input type="number" step="any" v-model="localPriceTable.expected_delivery" placeholder="Thời gian dự kiến giao hàng">
                <el-select v-model="localPriceTable.expected_unit" slot="append" placeholder="Select">
                  <el-option
                    v-for="(unit, index) in priceTableHelpers.units"
                    :label="unit"
                    :value="index"
                    :key="index"
                    ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="Mô tả dịch vụ" prop="service_description">
              <el-input v-model="localPriceTable.service_description" placeholder="Mô tả dịch vụ">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="TP đi" class="is-required" prop="city_from_id">
              <el-select class="width-100" v-model="localPriceTable.city_from_id" filterable placeholder="Chọn TP đi" :multiple="true">
                <el-option
                  v-for="city in cities"
                  :key="city.id"
                  :label="city.name"
                  :value="city.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Vùng miền đến" class="is-required" prop="region_to_id">
              <el-select class="width-100" v-model="localPriceTable.region_to_id" filterable placeholder="Chọn vùng miền đến" :multiple="true">
                <el-option
                  v-for="region in regions"
                  :key="region.id"
                  :label="region.name"
                  :value="region.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="6">
            <el-form-item label="Giá" prop="amount">
              <el-input @focus="removeZero('amount')" @blur="addZero('amount')" v-model="localPriceTable.amount" placeholder="Giá">
                <template slot="append"><span class="text-red">{{localPriceTable.amount | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Phí thu hộ tối thiểu" prop="cod_min_fee">
              <el-input @focus="removeZero('cod_min_fee')" @blur="addZero('cod_min_fee')" v-model="localPriceTable.cod_min_fee" placeholder="Phí thu hộ tối thiểu">
                <template slot="append"><span class="text-red">{{localPriceTable.cod_min_fee | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Phí thu hộ (COD)" prop="cod_fee">
              <el-input type="number" step="any" @focus="removeZero('cod_fee')" @blur="addZero('cod_fee')" v-model="localPriceTable.cod_fee" placeholder="Phí thu hộ (COD)">
                <template slot="append"><span class="text-red">{{ localPriceTable.cod_fee | number(3) }} %</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Giá trị đơn hàng áp dụng" prop="cod_apply">
              <el-input  @focus="removeZero('cod_apply')" @blur="addZero('cod_apply')" v-model="localPriceTable.cod_apply" placeholder="Giá trị đơn hàng áp dụng">
                <template slot="append"><span class="text-red">{{localPriceTable.cod_apply | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="6">
            <el-form-item label="Cân nặng khởi điểm" prop="weight_first">
              <el-input @focus="removeZero('weight_first')" @blur="addZero('weight_first')" v-model="localPriceTable.weight_first" placeholder="Cân nặng khởi điểm">
                <template slot="append"><span class="text-orange">{{localPriceTable.weight_first | gam}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Cân nặng tối đa" prop="maximum_weight">
              <el-input  @focus="removeZero('maximum_weight')" @blur="addZero('maximum_weight')" v-model="localPriceTable.maximum_weight" placeholder="Cân nặng tối đa">
                <template slot="append"><span class="text-orange">{{localPriceTable.maximum_weight | gam}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Bước nhảy" prop="weight_step">
              <el-input @focus="removeZero('weight_step')" @blur="addZero('weight_step')" v-model="localPriceTable.weight_step" placeholder="Bước nhảy">
                <template slot="append"><span class="text-orange">{{localPriceTable.weight_step | gam}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Giá bước nhảy" prop="weight_step_fee">
              <el-input  @focus="removeZero('weight_step_fee')" @blur="addZero('weight_step_fee')" v-model="localPriceTable.weight_step_fee" placeholder="Giá bước nhảy">
                <template slot="append"><span class="text-red">{{localPriceTable.weight_step_fee | vnd}}</span></template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12" class="adddon-2">
            <el-form-item label="Phụ phí ngoại thành" prop="location_step_fee">
              <el-input @focus="removeZero('location_step_fee')" @blur="addZero('location_step_fee')" v-model="localPriceTable.location_step_fee" placeholder="Phụ phí ngoại thành">
                <span class="text-red" slot="append">{{localPriceTable.location_step_fee | vnd}}</span>
                <el-select v-model="localPriceTable.lsf_type" slot="prepend" placeholder="Select">
                  <el-option
                    v-for="(lsf_type, key, index) in priceTableHelpers.lsf_types"
                    :label="lsf_type"
                    :value="parseInt(key)"
                    :key="key"
                    ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" class="adddon-1">
            <el-form-item label="Phí chuyển hoàn" prop="return_fee">
              <el-input type="number" step="any" @focus="removeZero('return_fee')" @blur="addZero('return_fee')" v-model="localPriceTable.return_fee" placeholder="Phí chuyển hoàn">
                <template v-if="priceTableHelpers && priceTableHelpers.currencies" slot="append"><span class="text-red">{{ localPriceTable.return_fee | number(3) }} {{priceTableHelpers.currencies[localPriceTable.return_unit]}}</span></template>
                <el-select v-model="localPriceTable.return_unit" slot="prepend" placeholder="Select">
                  <el-option
                    v-for="(currency, index) in priceTableHelpers.currencies"
                    :label="currency"
                    :value="parseInt(index)"
                    :key="index"
                    ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" class="remove-margin">
          <el-col :span="12">
            <el-form-item label="Áp dụng riêng cho khách hàng" prop="apply_only_customer">
              <select-client v-model="localPriceTable.apply_only_customer" />
            </el-form-item>
          </el-col>
          <el-col :span="12" class="adddon-1">

          </el-col>
        </el-row>
        <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
      </el-form>
    </div>
  </section>
</template>

<script>
  import { head, forEach, findIndex } from 'lodash'
  import { addPriceTable } from 'src/api/pricetable'
  import PriceTableMixin from './mixins'
  import SelectClient from 'src/components/client/SelectClient'
  export default {
    name: 'NewPriceTable',
    mixins: [PriceTableMixin],
    components: {SelectClient},
    data() {
      return {
        isLoading: false
      }
    },
    methods: {
      validatorBeforeSubmit () {
        this.submitting = true
        this.$refs['create-price-table-form'].validate(async (valid) => {
          if (valid) {
            this.changedData = false
            let requests = []
            forEach(this.localPriceTable.city_from_id, cityTo => {
              forEach(this.localPriceTable.region_to_id, regionTo => {
                let data = {...this.localPriceTable}
                let city = this.cities[findIndex(this.cities, {id: cityTo})]
                let region = this.regions[findIndex(this.regions, {id: regionTo})]
                data.name += ` (${city.name}) (${region.name})`
                data.city_from_id = cityTo
                data.region_to_id = regionTo
                requests.push(addPriceTable(data))
              })
            })
            // Xử lý requests theo batch, mỗi batch 5 requests
            const batchSize = 5
            let results = []

            for (let i = 0; i < requests.length; i += batchSize) {
              const batch = requests.slice(i, i + batchSize)
              const batchResults = await Promise.all(batch)
              results = results.concat(batchResults)
            }
            // Xử lý kết quả
            let response = results[0]
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Tạo mới bảng giá thành công',
                  type: 'success'
                })
                this.reloadGsTableAfterRedirect({name: 'price-table'}, 'priceTables')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thất bại',
                  body: 'Tạo bảng giá thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                })
                this.toggleLoadding(false)
            }
          } else {
            this.submitting = false
            this.$store.dispatch('showNotify', {
              title: 'Vui lòng kiểm tra thông tin cần nhập',
              type: 'warning'
            })
            return false
          }
        })
      },
      newPriceTable () {
        this.localPriceTable = {
          carrier_id: undefined,
          service_id: undefined,
          service_mapping_id: undefined,
          city_from_id: [],
          region_to_id: [],
          amount: 0,
          cod_min_fee: 0,
          cod_fee: 0,
          cod_apply: 0,
          weight_first: 0,
          maximum_weight: 0,
          weight_step: 0,
          weight_step_fee: 0,
          lsf_type: 1,
          location_step_fee: 0,
          expected_unit: 0,
          expected_delivery: '',
          hour_apply: 0,
          name: '',
          service_description: '',
          return_fee: 0,
          return_unit: 0,
          apply_only_customer: ''
        }
        setTimeout(() => {
          this.watching = true
          this.isLoading = true
        }, 100)
      }
    }
  }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// NewPriceTable.vue?2ebac742